module.exports = "<ng-container [formGroup]=\"group\">\n\n</ng-container>\n"